import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import AssistantOutlinedIcon from '@mui/icons-material/AssistantOutlined';
import RailItem from 'components/transaction/components/panels/transaction/transactionSideBar/railItem/RailItem';
import { useIsProtocolPanelOpen } from 'features/stepByStepProtocol/hooks/useIsProtocolPanelOpen';
import { selectProtocolStatusByTransactionId } from 'features/stepByStepProtocol/store/stepByStepProtocolSelectors';
import { PROTOCOL_STATUS } from 'features/stepByStepProtocol/utils/protocol/constants';
import { RAIL_PANEL } from 'utils/railPanels';

// "Protocol" rail item: shown only when the transaction's location has a protocol. The host rail decides
// what a click does (pin / unpin the panel) and can pass `active` / `pressed`; otherwise the item shows the
// panel's pinned state.
function ProtocolRailItem({ transactionId, active, pressed, onClick, onMouseEnter }) {
    const isConfigured = useSelector((state) => selectProtocolStatusByTransactionId(state, transactionId) !== PROTOCOL_STATUS.NOT_CONFIGURED);
    const isOpen = useIsProtocolPanelOpen(transactionId);

    if (!isConfigured) return null;

    return (
        <RailItem
            icon={<AssistantOutlinedIcon />}
            label="Protocol"
            active={active ?? isOpen}
            pressed={pressed ?? isOpen}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            railItemId={RAIL_PANEL.PROTOCOL}
        />
    );
}

ProtocolRailItem.propTypes = {
    transactionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onClick: PropTypes.func.isRequired,
    active: PropTypes.bool,
    pressed: PropTypes.bool,
    onMouseEnter: PropTypes.func,
};

export default ProtocolRailItem;
